// extracted by mini-css-extract-plugin
module.exports = {"Clients":"styles_Clients__2e0nS","slider":"styles_slider__tpM_9","content":"styles_content__3XND5","client":"styles_client__3cWtX"};